import { BLACK_200, BLACK_300, BLACK_400, BLACK_500, BLACK_600, BLACK_700, BLACK_900, BLUE_GREY_200, BLUE_GREY_400, LILAC_200, LILAC_300, LILAC_400, LILAC_700, TRANSPARENT } from '../colors';
var linkListItemConfig = {
  roundedCorners: false,
  noHoverEffect: false,
  selected: false,
  disabled: false,
  controlState: 'none',
  avatarPosition: 'top',
  actionType: 'none',
  actionTypeProps: {},
  actionTypePosition: 'top',
  headingTextTransform: 'none',
  subHeadingTextTransform: 'none',
  ignoreDisabledStateForCardPress: false,
  config: {
    headingLottieSize: 13,
    controlStates: {
      none: {
        backgroundColor: TRANSPARENT,
        titleColor: BLACK_700,
        headingColor: BLACK_900,
        subHeadingColor: BLACK_700,
        subHeadingBoldColor: BLACK_700,
        infoTextColor: BLACK_700,
        avatarIconBackgroundColor: LILAC_400
      },
      hover: {
        backgroundColor: LILAC_300,
        titleColor: BLACK_700,
        headingColor: BLACK_900,
        subHeadingColor: BLACK_700,
        subHeadingBoldColor: BLACK_700,
        infoTextColor: BLACK_700,
        avatarIconBackgroundColor: LILAC_300,
        avatarIconBorderColor: LILAC_700
      },
      pressed: {
        backgroundColor: LILAC_400,
        titleColor: BLACK_700,
        headingColor: BLACK_900,
        subHeadingColor: BLACK_700,
        subHeadingBoldColor: BLACK_700,
        infoTextColor: BLACK_700,
        avatarIconBackgroundColor: LILAC_300
      },
      disabled: {
        backgroundColor: LILAC_200,
        titleColor: BLACK_600,
        headingColor: BLACK_500,
        subHeadingColor: BLACK_500,
        subHeadingBoldColor: BLACK_500,
        infoTextColor: BLACK_500,
        avatarIconBackgroundColor: BLACK_400,
        avatarIconColor: BLACK_700
      }
    }
  }
};
var linklistItemConfigWhite = Object.assign(Object.assign({}, linkListItemConfig), {
  config: Object.assign(Object.assign({}, linkListItemConfig.config), {
    controlStates: Object.assign(Object.assign({}, linkListItemConfig.config.controlStates), {
      none: Object.assign(Object.assign({}, linkListItemConfig.config.controlStates.none), {
        avatarIconBackgroundColor: BLUE_GREY_200
      }),
      hover: Object.assign(Object.assign({}, linkListItemConfig.config.controlStates.hover), {
        backgroundColor: BLACK_200,
        avatarIconBackgroundColor: BLUE_GREY_200,
        avatarIconBorderColor: BLUE_GREY_200
      }),
      pressed: Object.assign(Object.assign({}, linkListItemConfig.config.controlStates.pressed), {
        backgroundColor: BLACK_300,
        avatarIconBackgroundColor: BLUE_GREY_400
      }),
      disabled: Object.assign(Object.assign({}, linkListItemConfig.config.controlStates.disabled), {
        backgroundColor: TRANSPARENT,
        avatarIconBackgroundColor: BLUE_GREY_200,
        avatarIconColor: BLUE_GREY_400
      })
    })
  })
});
export default {
  light: linkListItemConfig,
  dark: linkListItemConfig,
  white: linklistItemConfigWhite
};